(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["headerrev"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((d) => d.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class WorldCupLiveTicker {
    constructor(element) {
      this.element = element;
      this.content = element.querySelector('.worldcup-live-ticker__content');
      this.status = element.querySelector('.worldcup-live-ticker__status');
      this.feedUrl = element.dataset.feedUrl || '';
      this.defaultText = element.dataset.defaultText || 'Let’s go Curaçao!';
      this.noMatchesText = element.dataset.noMatchesText || 'Showing last available World Cup match';
      this.lastMatchText = element.dataset.lastMatchText || 'Last match';
      this.errorText = element.dataset.errorText || 'Live feed unavailable';
      this.liveText = element.dataset.liveText || 'LIVE';
      this.htText = element.dataset.htText || 'HT';
      this.ftText = element.dataset.ftText || 'FT';
      this.flag = element.dataset.flag || '🇨🇼';
      this.mascot = element.dataset.mascot || '🦎';
      this.refreshSeconds = Math.max(30, parseInt(element.dataset.refreshSeconds || '60', 10));
      this.matchIndex = 0;
      this.matches = [];
      this.rotateTimer = null;
      this.refreshTimer = null;
      this.abortController = null;
      this.storageKey = 'curacao-worldcup-last-match-v1';
    }

    start() {
      this.renderSlogan(this.defaultText, '');

      if (!this.feedUrl) {
        const cachedMatch = this.readCachedMatch();
        if (cachedMatch) {
          this.matches = [cachedMatch];
          this.matchIndex = 0;
          this.renderCurrentMatch(true);
        } else {
          this.renderSlogan(this.defaultText, 'Setup');
        }
        return;
      }

      this.load();
      this.refreshTimer = window.setInterval(() => this.load(), this.refreshSeconds * 1000);
    }

    stop() {
      if (this.refreshTimer) window.clearInterval(this.refreshTimer);
      if (this.rotateTimer) window.clearInterval(this.rotateTimer);
      if (this.abortController) this.abortController.abort();
    }

    async load() {
      try {
        this.element.classList.add('is-updating');
        this.abortController = new AbortController();

        const response = await fetch(this.feedUrl, {
          method: 'GET',
          headers: { 'Accept': 'application/json' },
          cache: 'no-store',
          signal: this.abortController.signal
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const payload = await response.json();
        const extractedMatches = this.extractMatches(payload);
        const displayMatches = this.selectDisplayMatches(extractedMatches);

        if (!displayMatches.length) {
          const cachedMatch = this.readCachedMatch();
          if (cachedMatch) {
            this.matches = [cachedMatch];
            this.matchIndex = 0;
            this.renderCurrentMatch(true);
          } else {
            this.renderSlogan(this.noMatchesText, this.lastMatchText);
          }
          return;
        }

        this.matches = displayMatches;
        this.matchIndex = 0;
        this.cacheBestLastMatch(extractedMatches);
        this.renderCurrentMatch(!this.matches.some((match) => match.isLive || match.isHalfTime));
        this.startRotation();
      } catch (error) {
        if (error.name !== 'AbortError') {
          const cachedMatch = this.readCachedMatch();
          if (cachedMatch) {
            this.matches = [cachedMatch];
            this.matchIndex = 0;
            this.renderCurrentMatch(true);
          } else {
            this.renderSlogan(this.errorText, this.errorText, false, true);
          }
        }
      } finally {
        this.element.classList.remove('is-updating');
      }
    }

    extractMatches(payload) {
      const possibleArrays = [
        payload?.matches,
        payload?.data?.matches,
        payload?.data?.match,
        payload?.match,
        payload?.response,
        payload?.fixtures,
        payload?.events,
        payload?.data,
        Array.isArray(payload) ? payload : null
      ].filter(Array.isArray);

      const rawMatches = possibleArrays[0] || [];
      const singleMatches = [
        payload?.last_match,
        payload?.lastMatch,
        payload?.latest_match,
        payload?.latestMatch,
        payload?.current_match,
        payload?.currentMatch,
        payload?.data?.last_match,
        payload?.data?.lastMatch,
        payload?.data?.latest_match,
        payload?.data?.latestMatch
      ].filter((match) => match && typeof match === 'object' && !Array.isArray(match));

      return [...rawMatches, ...singleMatches]
        .map((match) => this.normalizeMatch(match))
        .filter((match) => match && (match.home || match.away));
    }

    normalizeMatch(match) {
      const home =
        match.home_team_country ||
        match.home_team?.country ||
        match.home_team?.name ||
        match.homeTeam?.name ||
        match.home_name ||
        match.home?.name ||
        match.teams?.home?.name ||
        match.localteam_name ||
        match.fixture?.teams?.home?.name ||
        '';

      const away =
        match.away_team_country ||
        match.away_team?.country ||
        match.away_team?.name ||
        match.awayTeam?.name ||
        match.away_name ||
        match.away?.name ||
        match.teams?.away?.name ||
        match.visitorteam_name ||
        match.fixture?.teams?.away?.name ||
        '';

      const homeScore = this.numberOrNull(
        match.home_team?.goals ??
        match.homeTeam?.score ??
        match.home_score ??
        match.score?.fullTime?.home ??
        match.score?.regularTime?.home ??
        match.score?.halfTime?.home ??
        match.goals?.home ??
        match.scores?.home_score ??
        match.localteam_score ??
        match.fixture?.goals?.home
      );

      const awayScore = this.numberOrNull(
        match.away_team?.goals ??
        match.awayTeam?.score ??
        match.away_score ??
        match.score?.fullTime?.away ??
        match.score?.regularTime?.away ??
        match.score?.halfTime?.away ??
        match.goals?.away ??
        match.scores?.away_score ??
        match.visitorteam_score ??
        match.fixture?.goals?.away
      );

      const rawStatus =
        match.status ||
        match.status_long ||
        match.status_short ||
        match.fixture?.status?.short ||
        match.fixture?.status?.long ||
        match.match_status ||
        match.time ||
        '';

      const minute =
        match.minute ||
        match.elapsed ||
        match.fixture?.status?.elapsed ||
        match.time_elapsed ||
        '';

      const kickoff =
        match.datetime ||
        match.date ||
        match.utcDate ||
        match.fixture?.date ||
        match.scheduled ||
        match.start_time ||
        '';

      const events = [
        ...(Array.isArray(match.home_team_events) ? match.home_team_events : []),
        ...(Array.isArray(match.away_team_events) ? match.away_team_events : []),
        ...(Array.isArray(match.events) ? match.events : [])
      ];

      const latestEvent = this.latestEventText(events);
      const normalizedStatus = String(rawStatus || '').trim();
      const normalizedMinute = minute ? String(minute).replace("'", '') : '';

      return {
        home: String(home || '').trim(),
        away: String(away || '').trim(),
        homeScore,
        awayScore,
        status: normalizedStatus,
        minute: normalizedMinute,
        kickoff,
        latestEvent,
        isLive: this.isLiveStatus(normalizedStatus, normalizedMinute),
        isFinal: this.isFinalStatus(normalizedStatus),
        isHalfTime: this.isHalfTimeStatus(normalizedStatus),
        hasScore: homeScore !== null && awayScore !== null
      };
    }

    selectDisplayMatches(matches) {
      const validMatches = matches.filter((match) => match.home && match.away);
      const liveMatches = validMatches.filter((match) => match.isLive || match.isHalfTime);
      const curacaoLiveMatches = liveMatches.filter((match) => this.isCuracaoMatch(match));

      if (curacaoLiveMatches.length) {
        return this.sortLiveMatches(curacaoLiveMatches);
      }

      if (liveMatches.length) {
        return this.sortLiveMatches(liveMatches);
      }

      const lastCuracaoMatch = this.findLastAvailableScoredMatch(validMatches.filter((match) => this.isCuracaoMatch(match)));
      if (lastCuracaoMatch) {
        return [lastCuracaoMatch];
      }

      const lastFinalMatch = this.findLastAvailableScoredMatch(validMatches);
      if (lastFinalMatch) {
        return [lastFinalMatch];
      }

      return [];
    }

    findLastAvailableScoredMatch(matches) {
      return matches
        .filter((match) => match.hasScore)
        .sort((a, b) => {
          const aTime = a.kickoff ? Date.parse(a.kickoff) || 0 : 0;
          const bTime = b.kickoff ? Date.parse(b.kickoff) || 0 : 0;
          return bTime - aTime;
        })[0] || null;
    }

    isCuracaoMatch(match) {
      const home = String(match.home || '').toLowerCase();
      const away = String(match.away || '').toLowerCase();
      return home.includes('curacao') || home.includes('curaçao') || home === 'cuw' ||
        away.includes('curacao') || away.includes('curaçao') || away === 'cuw';
    }

    cacheBestLastMatch(matches) {
      try {
        const lastMatch = this.findLastAvailableScoredMatch(matches);
        if (lastMatch) {
          window.localStorage.setItem(this.storageKey, JSON.stringify(lastMatch));
        }
      } catch (error) {
        // localStorage can be blocked; ignore safely.
      }
    }

    readCachedMatch() {
      try {
        const value = window.localStorage.getItem(this.storageKey);
        if (!value) return null;
        const match = JSON.parse(value);
        return match && match.home && match.away && match.hasScore ? match : null;
      } catch (error) {
        return null;
      }
    }

    latestEventText(events) {
      if (!events.length) return '';

      const relevant = events
        .filter((event) => {
          const type = String(event.type_of_event || event.type || event.detail || '').toLowerCase();
          return type.includes('goal') || type.includes('card') || type.includes('substitution') || type.includes('var');
        })
        .sort((a, b) => (this.numberOrNull(b.time || b.minute) || 0) - (this.numberOrNull(a.time || a.minute) || 0));

      const event = relevant[0];
      if (!event) return '';

      const minute = event.time || event.minute || '';
      const player = event.player || event.player_name || event.player?.name || '';
      const type = event.type_of_event || event.type || event.detail || 'Update';

      return `${minute ? minute + "'" : ''} ${type}${player ? ': ' + player : ''}`.trim();
    }

    numberOrNull(value) {
      if (value === null || value === undefined || value === '') return null;
      const number = Number(value);
      return Number.isFinite(number) ? number : null;
    }

    isLiveStatus(status, minute) {
      const text = String(status || '').toLowerCase();
      return Boolean(minute) && !this.isFinalStatus(status) ||
        ['live', 'in progress', '1st half', '2nd half', 'first half', 'second half', '1h', '2h', 'et', 'pen'].some((word) => text.includes(word));
    }

    isHalfTimeStatus(status) {
      const text = String(status || '').toLowerCase();
      return text === 'ht' || text.includes('half time') || text.includes('halftime');
    }

    isFinalStatus(status) {
      const text = String(status || '').toLowerCase();
      return ['ft', 'aet', 'finished', 'full time', 'after extra time', 'complete', 'completed'].some((word) => text.includes(word));
    }

    sortLiveMatches(matches) {
      return matches.sort((a, b) => {
        if (a.isLive !== b.isLive) return a.isLive ? -1 : 1;
        if (a.isHalfTime !== b.isHalfTime) return a.isHalfTime ? 1 : -1;
        const aTime = a.kickoff ? Date.parse(a.kickoff) || 0 : 0;
        const bTime = b.kickoff ? Date.parse(b.kickoff) || 0 : 0;
        return aTime - bTime;
      });
    }

    startRotation() {
      if (this.rotateTimer) window.clearInterval(this.rotateTimer);
      if (this.matches.length <= 1) return;

      this.rotateTimer = window.setInterval(() => {
        this.matchIndex = (this.matchIndex + 1) % this.matches.length;
        this.renderCurrentMatch(false);
      }, 5500);
    }

    renderCurrentMatch(isLastMatch = false) {
      const match = this.matches[this.matchIndex];
      if (!match) return;

      const score = match.homeScore !== null && match.awayScore !== null
        ? `${match.homeScore} - ${match.awayScore}`
        : 'vs';

      const statusText = match.isLive
        ? (match.minute ? `${this.liveText} ${match.minute}'` : this.liveText)
        : match.isHalfTime
          ? this.htText
          : isLastMatch || match.isFinal
            ? this.lastMatchText
            : this.formatKickoff(match.kickoff);

      this.element.classList.toggle('is-live', match.isLive);

      if (this.status) {
        this.status.textContent = statusText || this.lastMatchText;
        this.status.className = 'worldcup-live-ticker__status';
        if (match.isLive) this.status.classList.add('is-live');
        if (match.isFinal) this.status.classList.add('is-final');
        if (isLastMatch) this.status.classList.add('is-last');
      }

      this.content.innerHTML = `
        <span class="worldcup-live-ticker__slogan">
          <span aria-hidden="true">${this.escapeHtml(this.flag)}</span>
          <span>${this.escapeHtml(this.defaultText)}</span>
        </span>
        <span class="worldcup-live-ticker__separator" aria-hidden="true"></span>
        <span class="worldcup-live-ticker__match">
          <span class="worldcup-live-ticker__team">${this.escapeHtml(match.home)}</span>
          <span class="worldcup-live-ticker__score">${this.escapeHtml(score)}</span>
          <span class="worldcup-live-ticker__team">${this.escapeHtml(match.away)}</span>
        </span>
        ${match.latestEvent ? `
          <span class="worldcup-live-ticker__separator" aria-hidden="true"></span>
          <span class="worldcup-live-ticker__meta">
            <span class="worldcup-live-ticker__event">${this.escapeHtml(match.latestEvent)}</span>
          </span>
        ` : ''}
      `;
    }

    renderSlogan(message, statusText, isLive = false, isError = false) {
      this.element.classList.toggle('is-live', isLive);
      this.content.innerHTML = `
        <span class="worldcup-live-ticker__slogan">
          <span aria-hidden="true">${this.escapeHtml(this.flag)}</span>
          <span aria-hidden="true">${this.escapeHtml(this.mascot)}</span>
          <span>${this.escapeHtml(message)}</span>
        </span>
      `;

      if (this.status) {
        this.status.textContent = statusText || '';
        this.status.className = 'worldcup-live-ticker__status';
        if (isLive) this.status.classList.add('is-live');
        if (isError) this.status.classList.add('is-error');
      }
    }

    formatKickoff(value) {
      if (!value) return '';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);

      return new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
        hour: '2-digit',
        minute: '2-digit',
        day: '2-digit',
        month: 'short'
      }).format(date);
    }

    escapeHtml(value) {
      return String(value || '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character]));
    }
  }

  document.querySelectorAll('[data-worldcup-ticker]').forEach((ticker) => {
    const instance = new WorldCupLiveTicker(ticker);
    instance.start();

    document.addEventListener('shopify:section:unload', () => instance.stop(), { once: true });
  });



  } catch(e) { console.error(e); }
})();
})();
